module.exports = __webpack_public_path__ + "img/mail.bc9dc78f.svg";